import * as React from 'react';
import * as Redux from 'redux';
import { IState } from '../../reducers/index'
import { CategoryTerm } from './category-term'
import { ICategoryResult, ITerm, ICategories } from '../../state-helpers/categories';
import * as _ from 'lodash';
import { addUrlProps, UrlQueryParamTypes, subquery } from 'react-url-query';
import { resultsModel } from '../../reducers/results-model';
import { connect } from 'react-redux';
import { pushInUrlQuery } from 'react-url-query';
import { updatedSelectedCategoryCount } from '../../reducers/categories-model';
import { setSearchTerm, setPage, updateSearchCategory, setMobileCategoriesVisibility } from '../../actions/index';
import { ToggleFacets } from './facets-toggle';

export interface IMobileCategoryProps {
  categories: ICategoryResult[];
  dispatch: Redux.Dispatch<IState>;
  onUpdateSearchCategory(categories: ICategoryResult[]): void;
  isLoading: boolean;
  numberOfResults: number;
  selectedCategoryCount: number;
  mobileCategoriesVisibility: boolean;
  categoriesModel: ICategories;
}

export interface IMobileCategorySectionProps {
  categories: ICategoryResult[];
  category: ICategoryResult;
  dispatch: Redux.Dispatch<IState>;
  onUpdateSearchCategory(categories: ICategoryResult[]): void;
}

export interface IToggleMobileSectionProps extends IMobileCategorySectionProps {
  toggleTerm: ITerm;
}

interface StatesModel {
  id: string;
  display: string;
  selected: boolean;
}

//Determines how to render Categories
export enum RenderTemplate {
  DEFAULT,
  ONLINE_ONLY,
  STATES,
  NONE
}

const urlPropsQueryConfig = {
  queryCurrentCategories: { type: UrlQueryParamTypes.string, queryParam: "categories" },
}

function mapStateToProps(state, props) {
  return {
    categoriesProp: state.searchTerm,
  };
}

/**
 * Standard react-redux mapDispatchToProps
 */
function mapDispatchToProps(dispatch) {
  return {
    setCategoriesProps: (categories) => dispatch(updateSearchCategory(categories)),
  };
}

interface QueryProps {
  queryCurrentCategories: any;
}

export class MobileCategories extends React.Component<IMobileCategoryProps, any> {
  GetCategories() {
    return typeof (this.props.categories) != "undefined" && this.props.categories != null ? this.props.categories : [] as ICategoryResult[];
  }

  resetCategories() {
    var categoryList = _.cloneDeep(this.props.categories);

    for (var i = 0; i < categoryList.length; i++) {
      for (var k = 0; k < categoryList[i].terms.length; k++) {
        categoryList[i].terms[k].selected = false;
      }
    }

    this.props.onUpdateSearchCategory(categoryList);
  }

  GetRenderTemplate(props: IMobileCategorySectionProps, id: number) {
    switch (props.category.renderTemplate) {
      case RenderTemplate.ONLINE_ONLY:
        return <ToggleMobileCategorySection
          category={props.category}
          categories={props.categories}
          dispatch={props.dispatch}
          onUpdateSearchCategory={props.onUpdateSearchCategory}
          key={id}
          toggleTerm={props.category.terms.filter(t => t.term == "Online Only")[0]} />;
      case RenderTemplate.NONE:
        return;
      default: return <MobileCategorySection
        category={props.category}
        categories={props.categories}
        dispatch={props.dispatch}
        key={id}
        onUpdateSearchCategory={props.onUpdateSearchCategory}
      />
    }
  }

  render() {
    let hasVisibleCategories = false;
    let boundResetCategories = this.resetCategories.bind(this);

    return (
      <div className={'mobile-facets-wrapper ' + (this.props.numberOfResults == 0 ? 'no-results' : '')}>
 
        <ToggleFacets
          categories={this.props.categoriesModel.categories}
          dispatch={this.props.dispatch}
          onUpdateSearchCategory={this.props.onUpdateSearchCategory}
          selectedCategoryCount={this.props.selectedCategoryCount}
          mobileCategoriesVisibility={this.props.mobileCategoriesVisibility}
          categoriesModel={this.props.categoriesModel}
          numberOfResults={this.props.numberOfResults}
        />

        <div className={'mobile-search-facet search-facet ' + (this.props.mobileCategoriesVisibility ? 'active ' : '') + (this.props.numberOfResults == 0 ? 'no-results' : '')}>
          {
            this.props.isLoading
              ? <div className="search-facet-loading"></div>
              : null
          }

          <div className="search-facet-header">
            <ToggleFacets
              categories={this.props.categoriesModel.categories}
              dispatch={this.props.dispatch}
              onUpdateSearchCategory={this.props.onUpdateSearchCategory}
              selectedCategoryCount={this.props.selectedCategoryCount}
              mobileCategoriesVisibility={this.props.mobileCategoriesVisibility}
              categoriesModel={this.props.categoriesModel}
              numberOfResults={this.props.numberOfResults}
            />
          </div>

          <div className="search-facet-terms">
            {/*Map props to object and check template on facet*/}
            {this.GetCategories().map((item, i) => {
                hasVisibleCategories = true;
                const props = {
                  category: this.props.categories[i],
                  term: item,
                  onUpdateSearchCategory: this.props.onUpdateSearchCategory,
                  categories: this.props.categories,
                  dispatch: this.props.dispatch
                };
                return this.GetRenderTemplate(props, i);
            })}

            {/*If no visible facets, display a message*/}
            {(!this.props.isLoading && !hasVisibleCategories)
              ? <div className="search-facet-msg-empty">No Categories</div>
              : null
            }
          </div>

          {/*insert facetsResetLinkText*/}
          <div className="search-facet-reset">
            <button className="btn-reset" onClick={boundResetCategories}>Clear</button>
          </div>
        </div>
      </div>
    );
  }
}

export class MobileCategorySection extends React.Component<IMobileCategorySectionProps, any> {
  GetTerms() {
    return typeof (this.props.category) != "undefined" ? this.props.category.terms : [] as ITerm[];
  }

  render() {
      return (
        <div className="search-facet-item" id={'search-facet-' + (this.props.category.name != null ? this.props.category.name.replace(/\s+/g, '-').toLowerCase() : "")}>
          <div className="search-facet-item-header">
            <h5>{this.props.category.name}</h5>
          </div>

          <div className="search-facet-item-list">
            <fieldset>
              {this.GetTerms().map((item, i) =>
                <CategoryTerm category={this.props.category}
                  term={item}
                  onUpdateSearchCategory={this.props.onUpdateSearchCategory}
                  key={i}
                  categories={this.props.categories}
                />)}
            </fieldset>
          </div>
        </div>
      );
  }
}

//This component takes a specific term and renders it as a toggle facet
export class ToggleMobileCategorySection extends React.Component<IToggleMobileSectionProps, any> {
  //Toggle selection of Facet
  categoryTermChange(e) {
    var categoryList = _.cloneDeep(this.props.categories);

    for (var f = 0; f < categoryList.length; f++) {
      for (var i = 0; i < categoryList[f].terms.length; i++) {
        if (categoryList[f].terms[i].id === this.props.toggleTerm.id) {
          categoryList[f].terms[i].selected = !this.props.toggleTerm.selected;
        }
      }
    }
    this.props.onUpdateSearchCategory(categoryList);
  }
  render() {
    if (typeof (this.props.toggleTerm) === "undefined" || this.props.toggleTerm == null || !(this.props.toggleTerm.hits > 0))
      return null;

    var bindCategoryTermChange = this.categoryTermChange.bind(this);
    return (
      <div className="search-facet-toggle-wrapper">
        <div className="search-facet-item search-facet-toggle form-element-toggle">
          <input type="checkbox" id={this.props.toggleTerm.term} name="name" value="value" className="form-element-toggle" checked={this.props.toggleTerm.selected} onClick={bindCategoryTermChange} />
          <label htmlFor={this.props.toggleTerm.term}>

          </label>
          <div className="form-element-checkbox-text search-facet-toggle-text">
            <h5>{this.props.toggleTerm.term} ({this.props.toggleTerm.hits})</h5>
          </div>
        </div>
      </div>
    );
  }
}

export var ConnectedMobileCategories = addUrlProps({ urlPropsQueryConfig })(connect(mapStateToProps, mapDispatchToProps)(MobileCategories));



// WEBPACK FOOTER //
// ./node_modules/source-map-loader!./App/search-page/components/categories/categories-mobile.tsx